import React, { Component } from 'react'
import { connect } from 'react-redux'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'

import '@/companys/scb/assets/styles/components/disclaimer-dialog.scss'

const pdfUrlMap = {
  en_US: 'https://www.shacombank.com.hk/eng/tools/documents/download/personal/images/investment_Related/sec_tc_e_201808.pdf',
  zh_CN: 'https://www.shacombank.com.hk/tch/tools/documents/download/personal/images/Investment_Related/sec_tc_c_201808.pdf',
  zh_TW: 'https://www.shacombank.com.hk/tch/tools/documents/download/personal/images/Investment_Related/sec_tc_c_201808.pdf'
}


class DisclaimerDialog extends Component {
  constructor(props) {
    super(props)
    this.handleCancelClick = this.handleCancelClick.bind(this)
  }

  handleCancelClick() {
    window.location.href = iTradeEnv.thirdPartyLink
  }

  render() {
    const { language, onSubmit } = this.props
    return (
      <div className="scb-disclaimer-dialog">
        <div className="disclaimer-text">
          <span>{language.disclaimer_reading}</span>
          《<a href={pdfUrlMap[language.lang]} target="_blank">{language.disclaimer_info}</a>》
        </div>
        <div className="disclaimer-action">
          <button className='disclaimer-cancel action-on' onClick={this.handleCancelClick}>{language.common_cancel}</button>
          <button className='disclaimer-ok action-yes' onClick={onSubmit}>{language.common_ok}</button>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({ language: state.app.language })
)(DisclaimerDialog)
